const SET_PARKING = "SET_PARKINGID"
const SET_AREA = "SET_AREA"
const SET_PROPERTY="SET_PROPERTY"

const state = {
    oneParking: null,
    area: null,
    property:null,

}
const mutations = {
    [SET_PARKING]: function (state, payload) {
        state.oneParking = payload;
    },
    [SET_AREA]: function (state, payload) {
        state.area = payload;
    },
    [SET_PROPERTY]:function(state,payload){
        state.property=payload;
    }
    
}
const actions = {
    setParking({ commit }, payload) {
    
        commit('SET_PARKINGID', payload)
    },
    setArea({ commit }, payload) {
        commit('SET_AREA', payload)
    },
    setProperty({commit},payload){
        commit("SET_PROPERTY",payload);
    }
    
}

export const parking=  {
    namespaced: true,
    state,
    mutations,
    actions
}